import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import MainAdUnitContainer from
'@fuww/library/src/Advertisement/MainAdUnitContainer';
import { MobileAdUnitContainer } from
'@fuww/library/src/Advertisement/AdUnitContainer';
import TopNewsSection from './Featured/TopNewsSection';
import SiteContext from '../../SiteContext';
import InView from '../../InView';
import AdUnit, { hasAdunit } from '../../../lib/adunit';

const ArticleLayout = ({
  featuredVariables,
  moreNewsVariables,
  categorySection,
  showCreatedAt,
  expandedSections,
}) => {
  const { newsboard } = useContext(SiteContext);

  return (
    <>
      <TopNewsSection
        variables={featuredVariables}
        showCreatedAt={showCreatedAt}
        expandedSections={expandedSections}
        moreNewsVariables={moreNewsVariables}
      />
      {hasAdunit(newsboard) && (
        <>
          <MainAdUnitContainer>
            <AdUnit
              adUnit="home_leaderboard2"
              sizes={[[1, 1], [728, 90], [970, 90], [970, 250]]}
              minHeight="90px"
            />
          </MainAdUnitContainer>
          <MobileAdUnitContainer>
            <AdUnit
              adUnit="mobile_home_categories_above"
              sizes={[[320, 240], [300, 250]]}
              minHeight="90px"
            />
          </MobileAdUnitContainer>
        </>
      )}
      {categorySection && (
        <InView>
          {categorySection}
        </InView>
      )}
      {hasAdunit(newsboard) && (
        <MobileAdUnitContainer>
          <AdUnit
            adUnit="mobile_home_categories_below"
            sizes={[[320, 240], [300, 250]]}
            minHeight="90px"
          />
        </MobileAdUnitContainer>
      )}
    </>
  );
};

ArticleLayout.propTypes = {
  /** Add or overwrite featured variables */
  featuredVariables: PropTypes.shape({
    categoryIds: PropTypes.arrayOf(PropTypes.number),
  }),
  /** Add or overwrite more news variables */
  moreNewsVariables: PropTypes.shape({
    categoryIds: PropTypes.arrayOf(PropTypes.number),
  }),
  categorySection: PropTypes.node,
  /** Show or hide date posted. */
  showCreatedAt: PropTypes.bool,
  /** Set moreNews for "Featured" and "More News" block */
  expandedSections: PropTypes.bool,
};

ArticleLayout.defaultProps = {
  featuredVariables: null,
  moreNewsVariables: null,
  categorySection: null,
  showCreatedAt: false,
  expandedSections: false,
};

export default ArticleLayout;
